import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { buildDynamicLinkForRef, constructArtificialLinkNode } from "../../../utils/links";
import { getProductPrices } from "../productList/utils";
import Rating from "../productList/sub-components/ProductRating";
import ProductModal from "./ProductModal";
import Image from "../image/Image";
import LinkWrapper from "../linkWrapper/LinkWrapper";
import { decodeText } from "../../../utils/richText";

const ProductTeaser = ({ product, currency, addToCart, addToWishlist, addToCompare, cartItem, wishlistItem, compareItem }) => {
    const [modalShow, setModalShow] = useState(false);

    const productLinkNode = constructArtificialLinkNode({ value: buildDynamicLinkForRef("PRODUCT_DETAIL", product) });
    const { discountedPrice, finalProductPrice, finalDiscountedPrice } = getProductPrices(
        product.price,
        product.discount,
        currency.currencyRate,
    );

    return (
        <Fragment>
            <div className="product-wrap">
                {product.image && product.image.length > 0 && (
                    <div className="product-img">
                        <LinkWrapper linkNode={productLinkNode} renderChildren={true}>
                            <Image imageNode={product.image[0]} className="default-img" />
                            {product.image.length > 1 && <Image imageNode={product.image[1]} className="hover-img" />}
                        </LinkWrapper>
                        {(product.discount || product.new) && (
                            <div className="product-img-badges">
                                {product.discount ? <span className="pink">-{product.discount}%</span> : ""}
                                {product.new ? <span className="purple">New</span> : ""}
                            </div>
                        )}

                        <div className="product-action">
                            <div className="pro-same-action pro-wishlist">
                                <button
                                    className={wishlistItem !== undefined ? "active" : ""}
                                    disabled={wishlistItem !== undefined}
                                    title={wishlistItem !== undefined ? "Added to wishlist" : "Add to wishlist"}
                                    onClick={() => addToWishlist(product)}
                                >
                                    <i className="pe-7s-like" />
                                </button>
                            </div>
                            <div className="pro-same-action pro-cart">
                                {product.affiliateLink ? (
                                    <a href={product.affiliateLink} rel="noopener noreferrer" target="_blank">
                                        {" "}
                                        Buy now{" "}
                                    </a>
                                ) : product.variation && product.variation["@nodes"].length >= 1 ? (
                                    <LinkWrapper linkNode={productLinkNode}>Select Option</LinkWrapper>
                                ) : product.stock && product.stock > 0 ? (
                                    <button
                                        onClick={() => addToCart(product)}
                                        className={cartItem !== undefined && cartItem.quantity > 0 ? "active" : ""}
                                        disabled={cartItem !== undefined && cartItem.quantity > 0}
                                        title={cartItem !== undefined ? "Added to cart" : "Add to cart"}
                                    >
                                        {" "}
                                        <i className="pe-7s-cart"></i>{" "}
                                        {cartItem !== undefined && cartItem.quantity > 0 ? "Added" : "Add to cart"}
                                    </button>
                                ) : (
                                    <button disabled className="active">
                                        Out of Stock
                                    </button>
                                )}
                            </div>
                            <div className="pro-same-action pro-quickview">
                                <button onClick={() => setModalShow(true)} title="Quick View">
                                    <i className="pe-7s-look" />
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                <div className="product-content text-center">
                    <h3>
                        <LinkWrapper linkNode={productLinkNode} renderChildren={true}>
                            {decodeText(product.displayName)}
                        </LinkWrapper>
                    </h3>
                    {product.rating && product.rating > 0 ? (
                        <div className="product-rating">
                            <Rating ratingValue={product.rating} />
                        </div>
                    ) : (
                        ""
                    )}
                    <div className="product-price">
                        {discountedPrice !== null ? (
                            <Fragment>
                                <span>{currency.currencySymbol + finalDiscountedPrice}</span>{" "}
                                <span className="old">{currency.currencySymbol + finalProductPrice}</span>
                            </Fragment>
                        ) : (
                            <span>{currency.currencySymbol + finalProductPrice} </span>
                        )}
                    </div>
                </div>
            </div>

            {/* product modal */}
            <ProductModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                product={product}
                currency={currency}
                discountedprice={discountedPrice}
                finalproductprice={finalProductPrice}
                finaldiscountedprice={finalDiscountedPrice}
                cartitem={cartItem}
                wishlistitem={wishlistItem}
                compareitem={compareItem}
                addtocart={addToCart}
                addtowishlist={addToWishlist}
                addtocompare={addToCompare}
            />
        </Fragment>
    );
};

ProductTeaser.propTypes = {
    addToCart: PropTypes.func,
    addToCompare: PropTypes.func,
    addToWishlist: PropTypes.func,
    cartItem: PropTypes.object,
    compareItem: PropTypes.object,
    currency: PropTypes.object,
    product: PropTypes.object,
    wishlistItem: PropTypes.object,
};

export default ProductTeaser;
